import React from 'react'
import { CardElement } from '@stripe/react-stripe-js'
import {
  subtitlesColor,
  suggestiveColor,
  errorColor,
} from '@/style-guide/colors'
import './CardSection.css'

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: subtitlesColor,
      fontFamily: '"Roboto", system-ui',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: suggestiveColor,
      },
    },
    invalid: {
      color: errorColor,
      iconColor: errorColor,
    },
  },
}

const CardSection = ({ onChange }) => (
  <CardElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />
)

export default CardSection
